"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEnterOrSpace = _interopRequireDefault(require("../../helpers/isEnterOrSpace"));

var _animateScroll = _interopRequireDefault(require("../../helpers/animateScroll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AnchorLink = function AnchorLinkComponent(_ref) {
  var className = _ref.className,
      children = _ref.children,
      href = _ref.href;

  var handleAnchorClick = function handleAnchorClick(event) {
    event.preventDefault();
    var targetOffset = document.querySelector(href).offsetTop;
    (0, _animateScroll["default"])(targetOffset);
  };

  return /*#__PURE__*/_react["default"].createElement("a", {
    href: href,
    tabIndex: 0,
    rel: "noopener noreferrer",
    target: "_self",
    className: "link-wrapper ".concat(className),
    onClick: function onClick(event) {
      return handleAnchorClick(event);
    },
    onKeyPress: function onKeyPress(event) {
      return (0, _isEnterOrSpace["default"])(event) && handleAnchorClick(event);
    }
  }, children);
};

AnchorLink.propTypes = {
  className: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].element)]).isRequired,
  href: _propTypes["default"].string.isRequired
};
var _default = AnchorLink;
exports["default"] = _default;